import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk, RootState} from "../../app/store";
import {BusinessPartnerMeta, BusinessPartnerMetaJSON, BusinessPartnerMetaFactory} from "../../models/models";
import Config from "../../config";

interface BusinessPartnerMetaState {
  isFetching: boolean;
  businessPartners: BusinessPartnerMeta[];
}

const initialState: EventState = {
  isFetching: false,
  businessPartners: []
};

export const brandingSlice = createSlice({
  name: "branding",
  initialState,
  reducers: {
    storeFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
    storeBusinessPartners: (state, action: PayloadAction<BusinessPartnerMeta[]>) => {
      state.businessPartners = action.payload;
    },
    purgeStore: (state) => {
      state.businessPartners = [];
    },
  },
});

export const { storeBusinessPartners, purgeStore } = brandingSlice.actions;

export const retrieveBranding =
  (authToken: string, eventID: string): AppThunk =>
  async (dispatch) => {
    try {
      const headers: Headers = new Headers();

      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", `Bearer ${authToken}`);

      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/business_partner_meta/${eventID}/`;

      fetch(url, {
        method: "GET",
        headers: headers,
      })
        .then((response) => response.json())
        .then((data) => {
          dispatch(purgeStore());

          const thisFactory = new BusinessPartnerMetaFactory();
          const businessPartners = data.business_partners.map((thisBP: BusinessPartnerMetaJSON) => thisFactory.fromJSON(thisBP))
          dispatch(storeBusinessPartners(businessPartners));
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

export const selectBranding = (state: RootState) => {
  //can filter for booked branding only here
  //const filteredBusinessPartners = state.brandingStore.businessPartners.map((bp) => bp);

  //filter for those BPs that have a logo and branding defined
  const filteredBusinessPartners = state.brandingStore.businessPartners.filter((bp) => bp.logo && bp.bookedDigitalBranding);
//  let test = []
//  test = filteredBusinessPartners.slice(0,2);
//  test = state.brandingStore.businessPartners.map((bp) => bp);
//  return test
  return filteredBusinessPartners
}

export const selectIsFetching = (state: RootState) =>
  state.brandingStore.isFetching;


export default brandingSlice.reducer;
